import { Order, OrderedProduct } from "src/shared/types";
import { ReverseAmounts } from "./useReturnCalculation";

export const buildReturnPayload = (order: Order, returnQty: Record<number, number>, totals: any, refundType: string, reverse: ReverseAmounts) => {
  const products: OrderedProduct[] = order.orderDetails?.[0]?.products ?? [];
  const now = new Date();

  const reverseDiscount = totals.reverseDiscount || reverse?.discount || 0;
  const reverseParcelFee = totals.reverseParcelFee || reverse?.parcelFee || 0;
  const reverseDeliveryFee = totals.reverseDeliveryFee || reverse?.deliveryFee || 0;

  // Calculate the new amount due after this return
  const paymentHistory = order.paymentHistory ?? [];

  const currentAmountDue = 
    paymentHistory.length > 0 
    ? Number(paymentHistory[paymentHistory.length - 1]?.amountDue ?? 0) 
    : Number(order.orders?.[0]?.remainingAmount ?? 0);

  // For Adj.Outstanding, the adjusted amount reduces the outstanding balance
  const adjustedAmount = totals.adjusted;
  const refundAmount = totals.refund;

  // New amount due after this return
  const newAmountDue = Math.max(0, currentAmountDue - adjustedAmount - refundAmount);

  return {
    returnProduct: products
      .map((p, i) => ({
        productId: p.productId,
        returnQty: returnQty[i] || 0,
        productName: p.name,
        arabicName: p.arabicName ?? "",
        unitPrice: Number(p.unitPrice),
      }))
      .filter((p) => p.returnQty > 0),
    Refund: {
      subTotal: totals.amount,
      discount: reverseDiscount,
      parcelFee: reverseParcelFee,
      deliveryFee: reverseDeliveryFee,
      refundType,
      refundAmount: refundAmount,
      adjustedAmount: adjustedAmount,
      amountDue: newAmountDue, // ✅ Include the correct amount due
      returnDate: now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0"),
      returnTime: new Date().toTimeString().split(" ")[0].slice(0, 8),
    },
  };
};
